import React, { Component } from 'react';
import { Provider, useDispatch, useSelector } from 'react-redux';
import MoneyComponent from '../elements/MoneyComponent';
import Category from '../../models/Category';
import LoanPayoff from './LoanPayoff';
import CategoryNameComponent from './CategoryNameComponent';
import Tabs from './Tabs';
import NetIncome from './NetIncome';
import SummaryPieChart from './SummaryPieChart';
import MonthlySummaryGeneral from '../pages/MonthlySummaryGeneral';
import store from '../../redux/store/store';
import getCategoryGroupsByType from '../../utilities/getCategoryGroupsByType';
import Tab from "./navigation/Tab.jsx";
import { summaryTabChanged } from "../../redux/actions/dashboard.js";

export default function MonthlySpendSummary({ selectedDate, selectedDates, transactions, categories, categoryGroups, categoryGroupsByType}) {
	const dispatch = useDispatch();
	const summaryPageSelectedTab = useSelector((state) => state.url.summaryPageSelectedTab);

	function onTabChange(selectedTab) {
		dispatch(summaryTabChanged(selectedTab));
	}

	return (
		<div className='spend_summary spend-tabs-container'>
			<Tabs
				onTabChange={onTabChange}
				activeTab={summaryPageSelectedTab}
			>
				{selectedDates &&
				<Tab label='Pie' className='selected_month_chart' icon='pie_chart'>
					<div className='row'>
						<div className='container'>
							<SummaryPieChart
								selectedDates={selectedDates}
								categories={categories}
								categoryGroups={categoryGroups}
								categoryGroupsByType={categoryGroupsByType}
							/>
						</div>
					</div>
				</Tab>
				}
				<Tab label='General' icon='home'>
					<Provider store={store}>
						<MonthlySummaryGeneral
							transactions={transactions}
							categories={categories}
							categoryGroups={categoryGroups}
						/>
					</Provider>
				</Tab>
				<Tab label='Net' icon='attach_money'>
					<Provider store={store}>
						<NetIncome
						/>
					</Provider>
				</Tab>
				<Tab label='Debt' icon='home'>
					<LoanPayoff
						type={LoanPayoff.types.LOANS}
						selectedDate={selectedDate}
						debtCategoryGroups={[...getCategoryGroupsByType(Category.types.LOANS), ...getCategoryGroupsByType(Category.types.EXPENSE)]}
					/>
				</Tab>
				<Tab label='Savings' icon='hot_tub'>
					<LoanPayoff
						type={LoanPayoff.types.SAVINGS}
						selectedDate={selectedDate}
						debtCategoryGroups={getCategoryGroupsByType(Category.types.SAVINGS)}
					/>
				</Tab>
			</Tabs>
		</div>
	);
}